import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import defaultRootReducer from '../reducers';

const { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: composeEnhancers = compose } = window;

export const enhancers = composeEnhancers(applyMiddleware(thunk));

export default (initialState = {}, rootReducer = defaultRootReducer) => {
  // expose store when run in Cypress
  if (window.Cypress) {
    window.store = createStore(rootReducer, initialState, enhancers);
  }
  return createStore(rootReducer, initialState, enhancers);
};
